import { DEALER_TIER } from '@motorway/mw-dealer-shared-components/types';

import useUser from './useUser';

const POWER_BUYERS = new Set([DEALER_TIER.POWER_BUYER, DEALER_TIER.POWER_BUYER_360]);

export const useIsUserPowerBuyer = () => {
	const user = useUser();

	return POWER_BUYERS.has(user?.dealerTier);
};

export default useIsUserPowerBuyer;
